import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { LOCATION_DROPDOWN_STORAGE_KEYS } from "components/LocationDropdown/storageKeys";
import { PERSISTED_DEALER_ID, persistItem } from "components/PersitanceManager";
import { typedQueryClient, useTypedQuery } from "hooks";
import { getPreference, setPreference } from "utils/common";

import type { Dealer } from "models";

export const useSelectedDealer = () => ({
  selectedDealer: useTypedQuery({
    queryKey: DealersAndLocationsDropdownKeys.selectedDealer,
    initialData: getPreference(LOCATION_DROPDOWN_STORAGE_KEYS.DealerSelectedPreference, null)
  }).data
});

export const setSelectedDealer = (dealer: Dealer) => {
  typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.selectedDealer, dealer);
  persistItem(PERSISTED_DEALER_ID, dealer.id.toString());
  setPreference(LOCATION_DROPDOWN_STORAGE_KEYS.DealerSelectedPreference, dealer);
};
